import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useState } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
    labels: ['Subjects', 'Tests / Exams'],
    datasets: [
        {
            label: '# of Votes',
            data: [35, 10],
            backgroundColor: [
                '#FF348E',
                '#58B7C2',
            ],
            borderWidth: 1,

        },
    ],
};

const EventChart = () => {
    const [chartData, setChartData] = useState(data)
    return <div style={{
        padding: '2rem'
    }}>
        <Doughnut data={chartData} options={{
            plugins: {
                legend: {
                    position: 'bottom',
                    align: 'center'
                }
            }
        }
        } />
    </div>
}

export default EventChart
